import { siteConfig } from "@/config/site";
import { buildApiUrl, publicAppEnv } from "@/lib/config";

/**
 * Клиентская телеметрия лендинга → `POST /api/client-observability` → Prometheus.
 *
 * Отдельным модулем, а не внутри `ClientObservability.tsx`: события шлёт не
 * только глобальный наблюдатель ошибок, но и витрина тарифов
 * (`paywall_price_ready` / `paywall_price_timeout`). На Scriptario адрес —
 * `NEXT_PUBLIC_API_BASE_URL` (прод: `https://api.scriptario.com`).
 */
export const OBSERVABILITY_PATH = "/api/client-observability";
const client = "landing";

export function clientObservabilityEndpoint() {
  return buildApiUrl(OBSERVABILITY_PATH);
}

/**
 * Классификация ошибки — та же, что в кабинете (`transcripta-frontend`
 * `src/utils/clientObservability.js`), чтобы `errorKind` у одинаковых событий
 * (`paddle_init_error`, `paddle_price_preview_error`) значил одно и то же.
 */
export function errorKind(error: unknown) {
  const value = error as { name?: string; message?: string };
  const name = String(value?.name || "").toLowerCase();
  const message = String(value?.message || error || "").toLowerCase();
  if (name.includes("timeout") || message.includes("timeout")) return "timeout";
  if (name.includes("network") || message.includes("network") || message.includes("failed to fetch")) return "network";
  if (
    message.includes("unauthorized")
    || message.includes("authorization")
    || message.includes("jwt")
    || message.includes("token")
    || message.includes("требуется авторизация")
    || message.includes("авторизац")
  ) return "auth";
  if (name || message) return "javascript";
  return "other";
}

export function recordClientEvent(event: Record<string, unknown>) {
  if (typeof window === "undefined") return;
  const body = JSON.stringify({
    client,
    env: publicAppEnv || "production",
    surface: "landing",
    outcome: "error",
    // Язык страницы нужен бэкенду для воронки пейвола по рынкам. Страну он
    // считает сам по IP, поэтому от клиента её не ждёт.
    locale: siteConfig.locale,
    ...event,
  });

  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      if (navigator.sendBeacon(clientObservabilityEndpoint(), blob)) return;
    }
  } catch {
    // Fall through to fetch.
  }

  fetch(clientObservabilityEndpoint(), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
    keepalive: true,
  }).catch(() => {});
}
